import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_d42s9nfu: FaireBrandEntity = {
  token: "b_d42s9nfu",
  type: "brand",
  name: "Candylab Toys",
  avatarUrl:
    "https://cdn.faire.com/fastly/b5d7839750bdb5e42924706fbc83d5e39c25e751a251363aefcf2906d9af852b.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/75363131d284f1551eff2327b965cd7c2e09736eb65413a390398dda1da0863d.png",
  logoUrl:
    "https://cdn.faire.com/fastly/b5d7839750bdb5e42924706fbc83d5e39c25e751a251363aefcf2906d9af852b.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/75363131d284f1551eff2327b965cd7c2e09736eb65413a390398dda1da0863d.png",
  location: "New York, NY, USA",
  minimumOrderDollars: 406,
  rating: 4.9,
  reviewCount: 121,
  isTopShop: true,
  isInsider: true,
  description:
    "Candylab Toys was born out of our desire to revive the glamorous '60s American modernist vibe and carve it into awesome contemporary wood toy designs. As artists, designers and parents we draw on many influences, not least of which are our deep love of classic American Cars and the craftsmanship spirit of mid-century artisan furniture designers.",
  meta: {
    source: "api",
    importedAt: "2026-05-21T20:36:08.916Z",
    importedBy: "entity-db-cli",
  },
};
